export enum FileIcons {
  DefaultIcon = 'insert_drive_file',
  VideoIcon = 'movie',
  PdfIcon = 'picture_as_pdf',
}
